import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Menu, X, LogOut, Search } from "lucide-react";
import { signOutRequest } from "../../redux/auth/auth.actions";

// Styled Components
const NavbarContainer = styled.header`
  background: linear-gradient(180deg, #1f3bb6 0%, #1e40af 60%, #1a2f84 100%);
  color: white;
  padding: 0.75rem 1.5rem;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.18), 0 3px 6px rgba(0, 0, 0, 0.12), inset 0 -1px 0 rgba(255, 255, 255, 0.06);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 64px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    height: 56px;
    padding: 0.5rem 1rem;
  }
`;

const NavbarContent = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
  gap: 2rem;
  // padding: 0 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr auto;
    gap: 1rem;
    padding: 0 1rem;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-self: start;
  margin-left: -1.5rem;
  padding-left: 1.5rem;

  @media (max-width: 768px) {
    margin-left: -1rem;
    padding-left: 1rem;
  }
`;

const CenterSection = styled.div`
  display: flex;
  justify-content: center;
  max-width: 400px;
  width: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-self: end;
  margin-right: -1.5rem;
  padding-right: 1.5rem;

  @media (max-width: 768px) {
    margin-right: -1rem;
    padding-right: 1rem;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 600px;
  background: linear-gradient(180deg, #ffffff, #f8fafc);
  border-radius: 14px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05), 0 6px 14px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  gap: 0.75rem;
`;

const SearchIcon = styled(Search)`
  color: #6b7280;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
`;

const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #1f2937;
  font-size: 0.9rem;
  font-weight: 400;

  &::placeholder {
    color: #9ca3af;
  }
`;


const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

const NavbarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const HamburgerButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;


const LogoutButton = styled.button`
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.08));
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.25);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 18px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.35);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.18) inset;
  }

  @media (max-width: 768px) {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
  }
`;

function Navbar({ onToggleMenu, isMenuOpen }) {
  const dispatch = useDispatch();

  const handleLogout = () => {
    console.log("Logout button clicked");
    dispatch(signOutRequest({ func: () => {} }));
  };

  return (
    <NavbarContainer>
      <NavbarContent>
        <LeftSection>
          <Logo>Sticker Checker</Logo>
        </LeftSection>
        
        <CenterSection>
          <SearchContainer>
            <SearchIcon size={18} />
            <SearchInput 
              type="text" 
              placeholder="Search cards..." 
            />
          </SearchContainer>
        </CenterSection>
        
        <RightSection>
          <HamburgerButton 
            onClick={onToggleMenu} 
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </HamburgerButton>
          
          <LogoutButton onClick={handleLogout}>
            <LogOut size={16} />
            Logout
          </LogoutButton>
        </RightSection>
      </NavbarContent>
    </NavbarContainer>
  );
}

export default Navbar;